import { Avatar, Box, Button, Image, Select, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RequestCallback from './RequestCallback';
import { useStreaks, useUser, useUserProfile } from '../../../hooks/V2/useUser';
import { useGetRequestCallback } from '../../../hooks/V2/useRequestCallback';
import { Link as RouterLink } from 'react-router-dom';
import { useDomainConfig, useDomainUIConfig } from '../../../hooks/useDomainConfig';
import UserDropdown from './UserDropdown';
import { useAllCourses } from '../../../hooks/V2/useCourse';
import { useSelectedCourse } from '../../../context/SelectedCourseContext';
import { sendTrackingEvent } from '../../../utils/gtm';
import { SAGEX_ORG_KEY } from '../../../utils/segexOrgName';
const MobileNav = () => {
	const navigate = useNavigate();
	const { data: domainConfig } = useDomainConfig({ uiHost: window.location.host });
	const { selectedCourse, setSelectedCourse } = useSelectedCourse();
	const { data: allCourses } = useAllCourses();
	// const [selectedCourse, setSelectedCourse] = React.useState('');
	const [openCallbackDrawer, setOpenCallbackDrawer] = useState(false);
	const [options, setOptions] = React.useState<
		{
			label: string;
			value: string;
		}[]
	>([]);

	const { data: streakCount } = useStreaks();
	const { data: userProfile } = useUserProfile();

	useEffect(() => {
		console.log('userProfile', userProfile);
	}, [userProfile, streakCount]);
	const { data: user, isLoading: userLoading } = useUser();
	const { data: getCallbacksData, isLoading: getCallbacksLoading } = useGetRequestCallback('prepleaf_nav');
	console.log(getCallbacksData);
	const domainUIConfig = useDomainUIConfig().data;

	useEffect(() => {
		if (!allCourses) {
			return;
		}
		const formattedData = allCourses
			// @ts-ignore
			//   don't forget to uncomment it
			?.filter(course => course.isActive)
			.map(course => {
				return {
					label: course.name,
					value: course._id,
					course: course,
				};
			});

		setOptions(formattedData);
		// add first course with isActive true to selectedCourse
		// if (formattedData.length > 0) {
		// 	setSelectedCourse(formattedData[1]);
		// }
	}, [allCourses]);

	return (
		<Box
			position="relative"
			zIndex="2"
			borderBottom={'1px solid #F3F2F2'}
			boxShadow={' 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.10)'}
			py="12px"
			px="16px"
			display={'flex'}
			justifyContent={'space-between'}
		>
			<Box
				cursor="pointer"
				onClick={() => {
					navigate('/');
				}}
				display="flex"
				alignItems="center"
			>
				<Image maxH="40px" src={domainConfig?.uiConfig?.orgLogo} />
			</Box>
			{user && !userLoading ? (
				<Box display="flex" gap="8px" alignItems={'center'}>
					{userProfile && userProfile.enrolments && userProfile.enrolments.length > 0 && selectedCourse?.value && (
						<Box display={{ base: 'none', md: 'flex' }} flexWrap="wrap" alignItems="center" gap="10px">
							<Box w="full" minW={{ md: '299px' }} maxW={{ md: '549px' }}>
								{allCourses && allCourses.length > 1 && (
									<Select
										height={'43px'}
										borderRadius={'8px'}
										borderColor="#CCC"
										_focus={{
											outline: 'none',
										}}
										value={selectedCourse.value}
										onChange={e => {
											setSelectedCourse(
												allCourses
													?.filter(c => c._id === e.target.value)
													.map(course => {
														return {
															label: course.name,
															value: course._id,
															course: course,
														};
													})[0],
											);
										}}
										fontWeight={600}
										fontSize={'16px'}
										lineHeight={'20px'}
										_active={{
											outline: 'none',
										}}
									>
										{options.map(option => (
											<option key={option.value} value={option.value}>
												{option.label}
											</option>
										))}
									</Select>
								)}
							</Box>
						</Box>
					)}
					{/* Request callback */}
					{SAGEX_ORG_KEY !== domainConfig?.key && (
						<Button
							p={{ base: '0px !important', md: '0px !important' }}
							rounded={{ base: '50%', md: '32px' }}
							h={{ base: '32px', md: '26px' }}
							minW="0px"
							minH="0px"
							w={{ base: '32px ', md: 'full' }}
							maxW="fit-content"
							textStyle="body2-md"
							gap={{ base: '8px', md: '0px' }}
							border={{
								base: '1px solid #D6E2FA !important',
								md: '1px solid #5D8DE9 !important',
							}}
							_hover={{ bg: 'rgba(93, 141, 233,.2)' }}
							_active={{ bg: 'rgba(93, 141, 233,.3)' }}
							justifySelf="right"
							textTransform={'none'}
							isLoading={getCallbacksLoading}
							isDisabled={
								getCallbacksLoading ||
								(getCallbacksData &&
									typeof getCallbacksData === 'object' &&
									!Array.isArray(getCallbacksData) &&
									getCallbacksData.source === 'prepleaf_nav')
									? true
									: false
							}
							onClick={() => {
								setOpenCallbackDrawer(true);
							}}
						>
							<Image h="full" alt="call" loading="lazy" src={'/images/phone-outline.svg'} />
							<Text p={{ base: '0px !important', md: '0px 6px !important' }} display={{ base: 'none', md: 'block' }}>
								Request Callback
							</Text>
						</Button>
					)}

					{SAGEX_ORG_KEY !== domainConfig?.key &&
						[
							{ redirectPath: '/streaks', imageUrl: '/images/streak-navbar.svg', count: streakCount || 0, color: '#CC926E', bgColor: '#F6EDE7' },
							{
								redirectPath: '/badges',
								imageUrl: '/images/badge-navbar.svg',
								count: userProfile?.badges?.length || 0,
								color: '#7261DF',
								bgColor: '#F7F7FF',
							},
						].map(({ imageUrl, color, bgColor, count, redirectPath }, index) => (
							<Box
								cursor="pointer"
								key={index}
								minW="36px"
								display={'flex'}
								justifyContent={'space-between'}
								bgColor={bgColor}
								border={`0.8px solid ${color}`}
								borderRadius={'24px'}
								px="6px"
								py="5px"
								onClick={() => {
									navigate(redirectPath);
									if (redirectPath == '/streaks') {
										sendTrackingEvent({
											event: 'cnd_header_streak',
											eventLabel: window.location.href,
										});
									} else if (redirectPath == '/badges') {
										sendTrackingEvent({
											event: 'cnd_header_badge',
											eventLabel: window.location.href,
										});
									}
								}}
							>
								<Box mx="auto" display={'flex'} alignItems={'center'} gap="4px">
									<Image boxSize={'14px'} src={imageUrl} />
									<Text mt="-2px" color={color} textStyle="body1" fontSize={'11px'} fontWeight={600} lineHeight={'19.2px'}>
										{count}
									</Text>
								</Box>
							</Box>
						))}
					<UserDropdown profileData={user} />
				</Box>
			) : (
				<>
					<Button
						bg="#4358F6"
						variant="primary"
						as={RouterLink}
						to={'/sign-in'}
						onClick={() => {
							sendTrackingEvent({
								event: 'cn_start_learnigng1',
								eventLabel: window.location.href,
							});
						}}
					>
						Start Learning
					</Button>
				</>
			)}
			<RequestCallback sourceType={'prepleaf_nav'} openCallbackDrawer={openCallbackDrawer} setOpenCallbackDrawer={setOpenCallbackDrawer} />
		</Box>
	);
};

export default MobileNav;
